import React, { useEffect, useState } from "react";
import { digitSperator } from "../../util/string";
import "./virtualMoneies.scss";

function VirtualMoney(props) {
    const [myData, setMyData] = useState([]);
    const [status, setStatus] = useState();

    const CustomTooltip = ({ active, label }) => {
        if (active) {
            return (
                <div className="my-tooltip">
                    <p>{props.data[label]} </p>
                </div>
            );
        }

        return null;
    };

    return (
        <div className="tmex-virtual-money">
            <div className="right-side">
                <div className="info">
                    <div className="icon">
                        <img src={props.image} alt="coin" />
                    </div>
                    <div className="name">
                        <h3>{props.id}</h3>
                        <h4>{props.name}</h4>
                    </div>
                </div>
                <div
                    onClick={() =>
                        window.location.replace(
                            localStorage.getItem("phone")
                                ? "/userpanel/order"
                                : "/authorization/"
                        )
                    }
                    className="button d-flex d-lg-none"
                >
                    <i className="fas fa-shopping-cart" />
                    <p>خرید</p>
                </div>
            </div>
            <div className="left-side">
                <div className="price">
                    <p>قیمت خرید و فروش: {digitSperator(props.price)}</p>
                </div>
            </div>
            <div
                onClick={() =>
                    window.location.replace(
                        localStorage.getItem("phone")
                            ? "/userpanel/order"
                            : "/authorization/"
                    )
                }
                className="button d-none d-lg-flex"
            >
                <i className="fas fa-shopping-cart" />
                <p>خرید</p>
            </div>
        </div>
    );
}

export default VirtualMoney;
